import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Hero from "@/components/klingon/Hero";
import VideoSection from "@/components/klingon/VideoSection";
import AppsShowcase from "@/components/klingon/AppsShowcase";
import AboutLore from "@/components/klingon/AboutLore";
import FooterSection from "@/components/klingon/FooterSection";

const Landing = () => {
  return (
    <div data-testid="qapla-landing" className="relative bg-[#050505] text-[#EAEAEA] min-h-screen">
      {/* Global overlays */}
      <div className="scanlines" aria-hidden="true" />
      <div className="crt-flicker" aria-hidden="true" />

      <main>
        <Hero />
        <VideoSection />
        <AppsShowcase />
        <AboutLore />
      </main>
      <FooterSection />
    </div>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
